/*
 *@description:'表单校验文件'
*/
// import debounce from "lodash.debounce";

import { passwordReg, accountReg, phoneReg, emailReg } from '@/utils/regular'

/**
 * 参数 item
 * required true  必填项默认不传为 true
 * type 特殊规则检验类型
 * errorMessage 提示的文本内容
 * min 和 max 必须同时给 min < max 输入字符的最大长度和 最小长度
 * maxLength  字符串的最大长度
 * */

// export function validator(list): Array<object> {
//   let rules: Array<object> = [];
//   if (list.length) {
//     list.map((item) => {
//       rules = [...validator1(item), ...rules];
//     });
//     return rules;
//   }
//   return validator1(list);
// }

/*
 *@description:'传参接口interface'
*/
interface Iparams {
  required?: boolean
  type?: string | null
  errMessage?: string | null
  min?: number | null
  max?: number | null
  maxLength?: number | null
  trigger?: string | Array<string>  //'blur'  or  'change'
}


/*
 *@description:'必传校验'
*/
export function mustPassValidator(params: Iparams) {
  const { required, errMessage = "请输入", trigger } = params;
  // console.log('必传校验');
  return {
    required: required,
    message: errMessage,
    trigger: trigger,
  }
}

/*
 *@description:'字符输入 最大长度校验'
*/
export function maxLengthValidator(params: Iparams) {
  const { required, min, maxLength, errMessage, trigger } = params
  // console.log('maxLengthValidator-----', errMessage);
  return {
    min: min,
    max: maxLength,
    message: errMessage,
    trigger: trigger,
  }
}


/*
 *@description:'字符输入最小程度校验和最大长度校验'
*/
export function minOrMaxValidator(params: Iparams) {
  const { min, max, errMessage, trigger } = params
  // console.log('minOrMaxValidator', trigger);
  return {
    min: min,
    max: max,
    message: errMessage,
    trigger: trigger,
  }
}


/*
 *@description:'密码 规则校验'
*/
export function passwordValidator(params: Iparams) {
  const { required, errMessage, trigger } = params
  const isvalidate = (rule, value, callback) => {
    if (value && !passwordReg(value)) {
      callback(new Error('8~30个字符，必须包含大小写字母、数字、特殊符号（如?@*%.，不支持:）'))
    } else {
      callback()
    }
    return true
  }
  return [
    {
      required: required,
      message: errMessage,
      trigger: trigger,
    },
    { validator: (rule, value, callback) => isvalidate(rule, value, callback), trigger }
  ]
}

/*
 *@description:'备份一个 防抖'
*/
// const debounceAccountValidator = debounce((rule, value, callback, params) => {
//   console.log('debounce=======',value && !accountReg(value));
//   if (value && !accountReg(value)) {
//     // console.log('!accountReg(value)----', !accountReg(value));
//     callback(new Error('6~30个字符，必须包含字母。可以使用大小写字母、数字、特殊符号（如?@*%.，不支持:）'))
//     return;
//   } else {
//     callback()
//   }
//   return true
// }, 500)
const debounceAccountValidator = (rule, value, callback) => {
  if (value && !accountReg(value)) {
    callback(new Error('6~30个字符，必须包含字母。可以使用大小写字母、数字、特殊符号（如?@*%.，不支持:）'))
    return;
  } else {
    callback()
  }
  return true
}

/*
 *@description:'登录账号 - 校验规则'
*/
export function accountValidator(params: Iparams) {
  const { required, errMessage, trigger } = params;
  return [
    {
      required: required,
      message: errMessage,
      trigger: trigger,
    },
    {
      validator: (rule, value, callback) =>
        debounceAccountValidator(rule, value, callback),
      trigger: trigger,
    }
  ]
}
/*
 *@description:'手机号格式 - 规则校验'
*/
export function phoneValidator(params: Iparams) {
  const { required, errMessage, trigger } = params;
  const isvalidate = (rule, value, callback) => {
    if (value && !phoneReg(value)) {
      callback(new Error('手机号格式不正确'))
    } else {
      callback()
    }
    return true

  }
  return [
    {
      required: required,
      message: errMessage,
      trigger: trigger,
    },
    { validator: (rule, value, callback) => isvalidate(rule, value, callback), trigger }
  ]
}


export function emailValidator(params: Iparams) {
  const { required, errMessage, trigger } = params;
  const isvalidate = (rule, value, callback) => {
    if (value && !emailReg(value)) {
      callback(new Error('邮箱格式不正确'))
    } else {
      callback()
    }
    return true

  }

  return [
    {
      required: required,
      message: errMessage,
      trigger: trigger,
    },
    { validator: (rule, value, callback) => isvalidate(rule, value, callback), trigger }
  ]

}


/*
 *@description:'validator 函数 默认参数'
*/
const defaultParams = {
  required: true,
  type: null,
  trigger: ["change", "blur"],
  errMessage: '请输入',
  min: 1,
  max: null,
  maxLength: 0
}

export function validator(data: Iparams): Array<object> {
  const params = {
    ...defaultParams,
    ...data
  }
  const { required, type, errMessage, min, max, maxLength, trigger } = params;
  // console.log('params----', params);
  let rules: Array<object> = [];
  if (required && !type) {//必传校验
    rules.push(mustPassValidator(params));
  }
  if (maxLength) {//字符输入最大长度校验
    rules.push(maxLengthValidator({
      ...params,
      errMessage: `最多输入${maxLength}个字符!`
    }));
  }
  if (min && max) {//字符输入最小和最大长度校验
    // console.log('min && max', min && max);
    rules.push(minOrMaxValidator({
      ...params,
      errMessage: `字符长度在${min}至${max}之间!`,
      trigger: 'blur'
    }));
  }

  if (type) {//特殊校验
    switch (type) {
      case "password":
        rules.push(...passwordValidator(params))
        break;
      case "account":
        rules.push(...accountValidator(params))
        break;
      case "phone":
        rules.push(...phoneValidator(params))
        break;
      case "email":
        rules.push(...emailValidator(params))
        break;
      default:
        rules.push({});
        break;
    }
  }
  return rules;
}
